
import { Base64 } from 'js-base64';

function GetConfig(key) {
	if (!key) {
		return {};
	}

	return JSON.parse(Base64.decode(document.getElementsByTagName('meta')
		.namedItem(`env-${key}`)
		.attributes.value.textContent));
}

function IsRouteAllowed(permission) {
	if (!permission) {
		return false;
	}

	return typeof GetConfig('navbar')[permission] !== 'undefined';
}

function GetOverride(label, modifier) {
	return GetConfig('school').labels[label][modifier];
}

function GetCurrency() {
	return GetConfig('school').currency;
}

function GetEnvironment() {
	return GetConfig('school').environment;
}

function GetSSODomain() {
	switch( GetEnvironment() ) {
		case 'test':
			return 'test-login.myschoolportal.co.uk';
		default:
			return 'login.myschoolportal.co.uk';
	}
}

function GetMIS() {
	return GetConfig('school').mis;
}

function GetAcademicYearStartMonth() {
	return parseInt(GetConfig('school').academic_year_start_month, 10);
}

function GetAcademicYearOffset() {
	return parseInt(GetConfig('school').academic_year_offset, 10);
}

function GetTimezone() {
	return GetConfig('school').timezone;
}

function GetMISOptions() {
	return GetConfig('school').mis_reference;
}

function GetWriteBack() {
	return GetConfig('school').mis_can_write_back;
}

function GetMisIsInternal() {
	return GetConfig('school').mis_is_internal;
}

function GetSchoolUrlBase() {
	return GetConfig('school').urlbase;
}

export {
	IsRouteAllowed,
	GetOverride,
	GetCurrency,
	GetEnvironment,
	GetMIS,
	GetSSODomain,
	GetAcademicYearStartMonth,
	GetTimezone,
	GetMISOptions,
	GetWriteBack,
	GetMisIsInternal,
	GetAcademicYearOffset,
	GetSchoolUrlBase,
};
